import { QuotePaymentTermCode } from '../quote-payment-term-code';
import { IQuotePaymentTermCodeData } from '../quote-payment-term-code.types';

export const mockQuotePaymentTermCodesData = (): IQuotePaymentTermCodeData[] => [
  { id: 1, code: 'APR' },
  { id: 2, code: 'N30' },
  { id: 3, code: 'N45' },
  { id: 4, code: 'N90' }
];

export const mockQuotePaymentTermCodes = () =>
  mockQuotePaymentTermCodesData().map(code => new QuotePaymentTermCode(code));
